import React, {
  useState,
  useEffect,
} from "react";
import "./DilemaCards.css";
import DilemaChart from "../DilemaChart/DilemaChart";
import VMTGChart from "../DilemaChart/VMTGChart";
import { END_URL, IMG_URL,SITE_URL } from "../../config";
import dil from "../../images/dile-img.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import SharePopup from "../ResultChart/SharePopup";

function DilemaCards({
  testlink,
  Dilemma,
  ArcheType,
  DilemmaTypes,
  UserResult,
  infoContent,
  DilemmaSlug,
  TierBreak,
  DilemmaShare
}) {

    const [copied, setCopied] = useState(false);
    const [isSharePopupOpen, setIsSharePopupOpen] = useState(false);
  
    const handleShare = () => {
  
          setIsSharePopupOpen(true);
      };
      
      const dilemma_name = Dilemma?.name;
  
      const dilemma_slug = dilemma_name
                          ? dilemma_name
                              .toLowerCase()
                              .trim()
                              .replace(/\s+/g, '-')
                              .replace(/[^\w\-]+/g, '')
                              .replace(/\-\-+/g, '-')
                              .replace(/^-+/, '')
                              .replace(/-+$/, '')
                          : '';         
  
      const shareUrl = `${IMG_URL}/view-image-result/${Dilemma?.id}/${dilemma_slug}?v=${Dilemma?.version}`;
  
  
      const filename=  Dilemma?.share_image?.split('/').pop() || "";
     
  
      const shareImg = `${Dilemma?.share_image}`;
  
      const shareTitle = Dilemma?.name || "Dilemma";
      const shareText = `${Dilemma?.name || "Dilemma"} result!`;


  return (
    <div
      className={`row dilema-cardBox ${!ArcheType?.name ? "dilema-cardBox-free" : ""}`}
    >
        <div className="col-12 col-md-4">
          <div className="dilema-cd1">

              <span>{Dilemma?.type_title}</span>

              <div className="dilema-cd1-img-fist">

                  <img src={`${IMG_URL}/d0/${Dilemma?.image}`} alt="" /> 

                  <div>
                          <h5>{Dilemma?.name}</h5>

                          <h6>{Dilemma?.letter}</h6>
                          </div>
              </div>

              <span dangerouslySetInnerHTML={{ __html: Dilemma?.description }} />

            {infoContent && (

              <div className="new-dil-cpnt">

                <p>{infoContent}</p>

              </div>
            )}

          </div>

        </div>


        {DilemmaTypes?.length > 0 && (
          <div className="col-12 col-md-4">
            <div className="dilema-cd1">

              <span>{TierBreak}</span>

              <div className="dilema-chart">
                <VMTGChart DilemmaTypes={DilemmaTypes} UserResult={UserResult} />

                <div className="dil-chart-btn">
                  <button>
                    {DilemmaTypes?.map((item, index) => (
                      <span key={index} style={{ color: item.letter_color }}>
                        {item.letter}
                      </span>
                    ))}
                  </button>

                  <div className="dil-chart-btn-info">

                      <p>{Dilemma?.letter_note}</p>

                  </div>

                </div>

              </div>

              <div className="flex items-center space-x-2 dilemma-share-image">
                                          
                    <button
                        className="button freereul"
                        onClick={handleShare}
                    >
                        {DilemmaShare || ' Share Result'}
                    <span>
                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                    </span>
                    </button>

                    {copied && (
                        <span className="ml-2 text-green-500 text-sm font-medium">
                        Link copied!
                        </span>
                    )}

              </div>

            </div>

          </div>
        )}

        {ArcheType?.name && (
          <div className="col-12 col-md-4">
            <div className="dilema-cd1">
              <span>{Dilemma?.arche_type_title}</span>

              <div className="dilema-cd1-img">
                <img src={`${IMG_URL}/d0/${ArcheType?.detailimage}`} alt="" />

                <div className="dilema-text">
                  <h5>{ArcheType?.name}</h5>

                  <p>{ArcheType?.description}</p>
                </div>
              </div>

              <a href={`/${testlink}`} class="continue-btn new-commom-btn">
                <span>View Archetype</span>

                <span class="righ-arr">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </a>
            </div>
          </div>
        )}

         <SharePopup
            isOpen={isSharePopupOpen}
            onClose={() => setIsSharePopupOpen(false)}
            shareUrl={shareUrl}
            shareImg={shareImg}
            shareTitle={shareTitle}
            shareText={shareText}
            TestUrl={`${SITE_URL}/dilemma/${DilemmaSlug}`}
            filename={filename}
        />

    </div>
  );
}

export default DilemaCards;
